var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgRebalancing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 236,
    height: 144,
    viewBox: "0 0 236 144",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "36.222%",
    y1: "50%",
    x2: "100%",
    y2: "69.201%",
    id: "b"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07949D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BFBF",
    offset: "83.681%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BFBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "31.571%",
    y1: "60.19%",
    x2: "78.375%",
    y2: "42.467%",
    id: "d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "red",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "58.156%",
    y1: "94.462%",
    x2: "100%",
    y2: "5.538%",
    id: "f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#07949D",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BFBF",
    offset: "73.159%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15BFBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-9.2%",
    y: "-12.4%",
    width: "118.4%",
    height: "124.8%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8,
    dy: 4,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0805817627 0 0 0 0 0.747718258 0 0 0 0 0.747718258 0 0 0 1 0",
    in: "shadowInnerInner1",
    result: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.5,
    in: "SourceAlpha",
    result: "shadowBlurInner2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 15,
    dy: -9,
    in: "shadowBlurInner2",
    result: "shadowOffsetInner2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner2",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0784313725 0 0 0 0 0.666666667 0 0 0 0 0.666666667 0 0 0 0.502229704 0",
    in: "shadowInnerInner2",
    result: "shadowMatrixInner2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixInner2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-18.1%",
    y: "-19.2%",
    width: "136.2%",
    height: "138.4%",
    filterUnits: "objectBoundingBox",
    id: "h"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: 9,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0823529412 0 0 0 0 0.749019608 0 0 0 0 0.749019608 0 0 0 1 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M116.012 71.574h-.378l-.234-.002a112.423 112.423 0 0 0-.239 0c-.456 0-.894.005-1.305.03h-.01a9.677 9.677 0 0 0-.15.011l.15-.01a10.34 10.34 0 0 0-.248.018l.097-.008a8.5 8.5 0 0 0-.58.065l.175-.025a6.675 6.675 0 0 0-.189.027l.013-.002a5.917 5.917 0 0 0-.136.022l.123-.02a5.66 5.66 0 0 0-.218.037l.095-.017a4.826 4.826 0 0 0-.497.114 3.434 3.434 0 0 0-.351.125l.058-.024c-.056.022-.11.046-.163.07l.105-.046c-.046.02-.092.04-.136.062l.031-.015a2.535 2.535 0 0 0-.157.08l.126-.065c-.056.027-.11.056-.162.086l.036-.02a2.31 2.31 0 0 0-.139.084l.103-.064c-.05.03-.098.06-.145.092l.042-.028c-.045.03-.088.06-.13.093l.088-.065c-.05.035-.098.07-.144.109l.056-.044a2.043 2.043 0 0 0-.122.101l.066-.057a2.01 2.01 0 0 0-.124.111l.058-.054c-.041.037-.08.075-.118.115l.06-.06a1.973 1.973 0 0 0-.11.116l.05-.056a1.976 1.976 0 0 0-.129.152l.078-.096c-.035.04-.068.082-.1.126l.022-.03a2.03 2.03 0 0 0-.099.14l.077-.11a2.05 2.05 0 0 0-.098.146l.021-.035c-.031.05-.061.1-.09.154l.069-.12a2.175 2.175 0 0 0-.09.162l-.076.167c-.943 2.313.814 3.385 3.21 3.394l.18-.002a8.488 8.488 0 0 0 .36-.014c.685-.04 1.407-.162 2.123-.36l.016-.004.124-.033.083-.022.197-.052.113-.028a28.139 28.139 0 0 1 .69-.164l.163-.037.171-.037.178-.038c.242-.051.504-.103.784-.156l.214-.039c.131-.024.267-.048.406-.071l.072-.012a36.4 36.4 0 0 1 .607-.097c6.221-.934 17.826-1.045 20.781 10.304l.046.202a3.362 3.362 0 0 1 .061.593l-.006-.168.006.123v.138l-.005.12-.001.02a3.055 3.055 0 0 1-.08.516l-.007.028a3.025 3.025 0 0 1-.282.718 3.123 3.123 0 0 1-.637.814 2.129 2.129 0 0 1-.107.094 2.557 2.557 0 0 1-.168.134l-.045.032a3.334 3.334 0 0 1-.11.076l-.02.013a3.159 3.159 0 0 1-.47.254l-.067.028a2.693 2.693 0 0 1-.097.039l-.054.02-.09.03-.062.02a2.585 2.585 0 0 1-.237.063 4.299 4.299 0 0 1-.173.035 3.6 3.6 0 0 1-.465.049h-.014a2.687 2.687 0 0 1-.256-.001 4.478 4.478 0 0 1-.367-.036 3.676 3.676 0 0 1-.35-.07c-2.249-.57-4.036-.897-5.896-.9l-.294.001a18.06 18.06 0 0 0-2.455.218l-.327.053c-.323.056-.655.12-.997.193-.384.081-.782.175-1.195.28-1.22.31-2.581.722-4.155 1.248-1.843.615-3.655 1.21-5.438 1.783l-.289.092c-40.902 13.136-65.988 15.288-83.13 8.07l-.005-.005C13.766 93.032 0 74.143 0 52.03l.007-.86C.465 22.83 23.531 0 51.917 0h7.11c28.673 0 51.917 23.294 51.917 52.03l-.01.993a53.41 53.41 0 0 1-.222 3.922c.002 0 .001.005 0 .012-.03.313-.062.625-.097.936.02 1.039.458 2.692 2.782 3.699.753.246 1.515.514 2.295.807l.106.04.285.107.06.025a37.634 37.634 0 0 1 .556.222l.084.035c.875.361 1.693.75 2.516 1.22.513.29.98.582 1.401.875l.01.008.196.137c.074.053.146.107.215.16l.018.014c2.661 2.013 2.334 4.316.186 5.453l-.064.032a5.334 5.334 0 0 1-.538.237l-.079.03a7.572 7.572 0 0 1-.262.09l-.043.013a7.899 7.899 0 0 1-.827.214 9.928 9.928 0 0 1-.826.138 12.53 12.53 0 0 1-.341.038 15.555 15.555 0 0 1-1.205.075 27.316 27.316 0 0 1-.966.012h-.162z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.045 0C60.726.011 55.953 10.423 55.27 11.626c-1.482 2.614-4.354 4.936-6.547 2.334-1.005-1.193-.111-3.4.669-4.66 1.317-2.13-.437-4.798-2.914-4.466C34.356 6.457 20.48 19.196 23.3 35.44c1.478 8.515 11.738 19.19 28.75 11.186C63.4 40.73 64.89 29.472 67.17 16.29c1.025-5.933 3.75-8.68 6.435-9.909 2.316-1.059 2.383-4.345.049-5.362C72.028.31 70.503.003 69.082 0h-.037z",
    id: "g"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#302631",
    d: "M212 65.847h24v77h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#413343",
    d: "M202 65.847h24v77h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B9AD9F",
    d: "M187 88.847h24v54h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DAD0C5",
    d: "M177 88.847h24v54h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DD581F",
    d: "M10 88.847h24v54H10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF6828",
    d: "M0 88.847h24v54H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ED9735",
    d: "M26 113.847h24v29H26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEA948",
    d: "M17 113.847h24v29H17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.051 145.236c-1.76 0-3.188-1.673-3.188-3.735V126.95c0-2.063 1.428-3.736 3.188-3.736 1.76 0 3.189 1.673 3.189 3.736v14.55c0 2.063-1.428 3.736-3.189 3.736",
    fill: "#1D1D1B"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(50.584 28.573)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.487-4.37c-9.173.006-14.436 5.762-15.188 6.427-1.635 1.445-4.8 2.728-7.219 1.29-1.109-.66-.123-1.88.737-2.577 1.453-1.177-.481-2.652-3.213-2.468-13.367.897-28.668 7.94-25.558 16.919 1.63 4.707 12.943 10.608 31.702 6.184 12.514-3.26 13.575-10.404 18.077-16 1.13-3.278 6.556-.989 9.518-1.668 2.554-.585-1.2-6.982-3.774-7.544a23.701 23.701 0 0 0-5.041-.563h-.04z",
    fill: "url(#d)",
    opacity: 0.354,
    mask: "url(#e)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.785 3.847)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#h)",
    xlinkHref: "#g"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M97.125 53.19c8.394 0 15.198 6.798 15.198 15.183 0 8.386-6.804 15.183-15.198 15.183-7.73 0-14.113-5.767-15.072-13.23h-4.998c-.959 7.463-7.342 13.23-15.073 13.23-8.393 0-15.197-6.797-15.197-15.183 0-8.385 6.804-15.182 15.197-15.182 7.769 0 14.176 5.823 15.086 13.339h4.971c.91-7.516 7.318-13.34 15.086-13.34zm-35.143 3.796c-6.295 0-11.398 5.098-11.398 11.387 0 6.29 5.103 11.387 11.398 11.387S73.38 74.662 73.38 68.373c0-6.289-5.103-11.387-11.398-11.387zm35.143 0c-6.294 0-11.397 5.098-11.397 11.387 0 6.29 5.103 11.387 11.397 11.387 6.295 0 11.398-5.098 11.398-11.387 0-6.289-5.103-11.387-11.398-11.387z",
    fill: "#3C363D",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3C363D",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M113 65.847h21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.178 67.868c0 1.419-1.148 2.57-2.564 2.57a2.567 2.567 0 0 1-2.564-2.57c0-1.42 1.148-2.57 2.564-2.57a2.566 2.566 0 0 1 2.564 2.57M93.169 67.868c0 1.419-1.148 2.57-2.564 2.57a2.567 2.567 0 0 1-2.564-2.57c0-1.42 1.148-2.57 2.564-2.57a2.566 2.566 0 0 1 2.564 2.57",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.127 72.694c-4.205 0-7.614 3.416-7.614 7.63H85.74c0-4.214-3.408-7.63-7.613-7.63",
    fill: "#FFDA00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.557 85.519a5.19 5.19 0 0 0 5.184-5.195H75.373a5.19 5.19 0 0 0 5.184 5.195",
    fill: "#F2A100"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.686 145.236c-1.76 0-3.188-1.673-3.188-3.735V126.95c0-2.063 1.428-3.736 3.188-3.736 1.761 0 3.188 1.673 3.188 3.736v14.55c0 2.063-1.427 3.736-3.188 3.736",
    fill: "#1D1D1B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgRebalancing);
export default __webpack_public_path__ + "static/media/img_rebalancing.a03779eb.svg";
export { ForwardRef as ReactComponent };